// Semantic equality of performed set facts (§9.4). A commit whose facts equal
// the stored ones is a no-op: it writes no revision, stamps no metadata and
// records no activity. Kept apart from performedRules.js, which mirrors the
// backend contract.

// Stamped by the reducer, never compared as athlete facts.
const SET_METADATA_FIELDS = new Set(["lastEditedAt", "enteredAfterFinish", "performedAt"]);

function sameDecimal(left, right) {
  const leftNumber = Number(left);
  const rightNumber = Number(right);
  if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
    return leftNumber === rightNumber;
  }
  return left === right;
}

function sameBarWeight(left, right) {
  if (left == null || right == null) return left == null && right == null;
  return left.unit === right.unit && sameDecimal(left.value, right.value);
}

// Loads compare by unit, convention, numeric value and bar, never by
// reference: "135.0" LB equals "135" LB.
export function sameLoad(left, right) {
  if (left == null || right == null) return left == null && right == null;
  return left.unit === right.unit &&
    left.convention === right.convention &&
    sameDecimal(left.value, right.value) &&
    sameBarWeight(left.barWeight, right.barWeight);
}

function sameFact(field, left, right) {
  if (field === "load") return sameLoad(left, right);
  return Object.is(left ?? null, right ?? null);
}

// True when applying `patch` to `set` would change no canonical fact.
export function isSetPatchNoOp(set, patch = {}) {
  return Object.keys(patch).every((field) =>
    SET_METADATA_FIELDS.has(field) || sameFact(field, set?.[field], patch[field])
  );
}
